module.exports = __webpack_public_path__ + "static/media/screen.e73085a4.svg";